export default __webpack_public_path__ + "static/media/cert-hr-cpttm.ea741d84.jpg";